import Immutable from 'immutable';

export interface RawUserProfile {
  firstname: string;
  lastname: string;
  company: string;
  role: string;
  discipline: string;
  additionalinfoneeded: boolean;
}

const defaultValues: RawUserProfile = {
  firstname: '',
  lastname: '',
  company: '',
  role: '',
  discipline: '',
  additionalinfoneeded: true,
};

export const UserProfileFactory = Immutable.Record(
  defaultValues,
  'UserProfile'
);

export class UserProfile extends UserProfileFactory {
  serialize(): RawUserProfile {
    return this.toJS();
  }

  static deserialize(rawUserProfile: RawUserProfile): UserProfile {
    return new UserProfile(rawUserProfile);
  }
}
